<template>
<router-link  v-if="type" :to="{ name: 'goodslist', params: {classname:classinfo.name,pid:classinfo.id,classid:0}}">
    <div v-if="activity" class="goodsitem"  @mouseover="onpic()" @mouseout="pic()">
        <div class="goodsitemimg">
            <img :src="classinfo.icon">
        </div>
        <div class="goodsitemicon">
            <img src="@/assets/common/images/yellowline.png">
        </div>
        <p>
            {{classinfo.name}}
        </p>
        
    </div>
     <div v-else class="goodsitem ongoodsitem" @mouseover="onpic()" @mouseout="pic()">
        <div class="goodsitemimg">
            <img  :src="classinfo.iconed">
        </div>
        <div class="goodsitemicon">
            <img src="@/assets/common/images/yellowline.png">
        </div>
        <p>
             {{classinfo.name}}
        </p>
        
    </div>
</router-link>
<router-link v-else :to="{ name: 'classIndex', params: {id:1}}">
    <div v-if="activity" class="goodsitem"  @mouseover="onpic()" @mouseout="pic()">
        <div class="goodsitemimg">
            <img :src="classinfo.icon">
        </div>
        <div class="goodsitemicon">
            <img src="@/assets/common/images/yellowline.png">
        </div>
        <p>
            {{classinfo.name}}
        </p>
        
    </div>
     <div v-else class="goodsitem ongoodsitem" @mouseover="onpic()" @mouseout="pic()">
        <div class="goodsitemimg">
            <img  :src="classinfo.iconed">
        </div>
        <div class="goodsitemicon">
            <img src="@/assets/common/images/yellowline.png">
        </div>
        <p>
             {{classinfo.name}}
        </p>
        
    </div>
</router-link>
  
</template>

<script>
export default {
    data(){
        return{
            activity:true
        }
    },
    props: {
        classinfo: {
            type: Object,
            default:() => ({})
        },
        type:{
            type:Boolean,
            default:true
        }
    },
    methods:{
        onpic:function(e){
            this.activity=false
        },
        pic:function(e){
             this.activity=true
        }
    }
}
</script>

<style scoped>
    img{
        font-size: 0px;
        vertical-align:middle   
    }
    .goodsitem{
        width: 152px;
        height: 172px;
        border: 1px solid #dfdfdf;
        border-radius: 10px;
        cursor:pointer;
    }
    .goodsitem div{
        margin: 0 auto;
    }
    .goodsitem .goodsitemimg{
        width: 100px;
        height: 95px;
        overflow: hidden;
        margin-top:15px;
        margin-bottom: 7px;
    }
    .goodsitem .goodsitemimg img{
        width: 100px;
        height: 95px;
    }


    .goodsitem .goodsitemicon{
        width: 21px;
        margin-bottom: 2px;
    }
    .goodsitem p{
        text-align: center;
        padding: 0;
        margin: 0;
        font-size: 18px;
        color: #666;
    }

    /**
    *背景
    *边框
    *文字
    */
     .ongoodsitem{
        border: 1px solid #2655ae;
        background-color: #2655ae;
    }
    .ongoodsitem p{
        color: #fff;
    }

</style>


// WEBPACK FOOTER //
// src/components/index/GoodsClassItem.vue